import orderBy from 'lodash/orderBy';
import {
  TicketInfoApiFragment,
  TicketKind,
} from '../../../../graphql/generated/types';
import {BuyAtOnceInfo} from '../type';

export function calculateBuyAtOnceInfo({
  ticketKind,
  purchasableTicketList,
  ticketlessCount = 0,
  ticketCount = 0,
}: {
  ticketKind: TicketKind;
  purchasableTicketList: TicketInfoApiFragment[] | undefined;
  ticketlessCount?: number;
  ticketCount?: number;
}): BuyAtOnceInfo | undefined {
  if (
    !purchasableTicketList ||
    purchasableTicketList.length === 0 ||
    !ticketlessCount
  ) {
    return;
  }
  const ticketList = orderBy(
    purchasableTicketList,
    ['totalTicketCount'],
    ['desc']
  );
  let remainNotReadCount = ticketlessCount - ticketCount;
  const result: BuyAtOnceInfo = {
    ticketKind,
    totalPrice: 0,
    remainNotReadCount,
    totalDiscount: 0,
    chunkList: [],
  };
  ticketList.forEach(ticket => {
    const quantity = Math.floor(remainNotReadCount / ticket.totalTicketCount);
    if (quantity < 1) {
      return;
    }
    result.totalPrice += quantity * ticket.price;
    result.totalDiscount += quantity * ticket.discount;
    result.chunkList.push({
      quantity,
      totalPrice: quantity * ticket.price,
      ticket,
    });
    remainNotReadCount -= quantity * ticket.totalTicketCount;
  });
  // 티켓 구입 시 순서와 packageOrder 순서가 같도록 보장합니다
  result.chunkList = orderBy(result.chunkList, ['packageOrder'], ['asc']);
  return result;
}
